import React from 'react';
import { DateRangesSelectDropdownContainer } from './DateRangesSelectDropdown.elements';
import { IcoChevron } from 'icons/indexed-icons/IcoChevron';
import { useTranslation } from 'react-i18next';
import { RangeProps, useWidgetDateRange } from '../providers/useWidgetDateRange';


export interface DateRangesSelectDropdownProps {
  ranges?: Record<string, RangeProps>;
  defaultLabel?: string;
  defaultDateRange?: string;
}

export const DateRangesSelectDropdown = ({
  ranges, 
  defaultLabel
}: DateRangesSelectDropdownProps): JSX.Element => {
  if (!ranges) return <></>;

  const { t } = useTranslation(['mh']);
  const { setDateRange, label } = useWidgetDateRange();

  const handleClick = (props: Record<string, unknown>) => {
    return setDateRange(props);
  };

 
  return (
    <DateRangesSelectDropdownContainer className="date-ranges-select-dropdown">
      <div className="date-ranges-select-dropdown__view-box">
        <div className="view-box__label">{label || defaultLabel}</div>
        <IcoChevron />
      </div>
      <div className="date-ranges-select-dropdown__dropdown-area">
        {Object.entries(ranges).map(([curlabel, vals]) => {
          return (
            <button
              key={curlabel}
              className={label === curlabel ? `is-selected` : undefined}
              type="button"
              onClick={() => handleClick({label: curlabel, ...vals})}
            >
              {t(curlabel)}
            </button>
          );
        })}
      </div>
    </DateRangesSelectDropdownContainer>
  );
};
